import { SiteConfig } from './SiteConfig';

export class SiteConfigBuilder {
  private siteConfig: SiteConfig = {};

  public withTenant(tenant: string): SiteConfigBuilder {
    this.siteConfig.tenant = tenant;
    return this;
  }

  public withCulture(culture: string): SiteConfigBuilder {
    this.siteConfig.culture = culture;
    return this;
  }

  public withVCSStoreUrl(vcsStoreUrl: string): SiteConfigBuilder {
    this.siteConfig.vcsStoreUrl = vcsStoreUrl;
    return this;
  }

  public build(): SiteConfig {
    return this.siteConfig;
  }
}
